module.exports = __webpack_public_path__ + "img/bvselchow2.089219a8.jpg";